import React, { Activity, useState } from 'react';

export function useVisitedTabs(activeId) {
  const [visited, setVisited] = useState(() => new Set([activeId]));

  if (!visited.has(activeId)) {
    const next = new Set(visited);
    next.add(activeId);
    setVisited(next);
    return next;
  }

  return visited;
}

export function KeepAlivePanel({
  id,
  activeId,
  visited,
  children,
  className = '',
}) {
  if (!visited?.has(id)) return null;

  const mode = activeId === id ? 'visible' : 'hidden';

  return (
    <Activity mode={mode} name={String(id)}>
      <div className={className} data-tab-panel={id}>
        {children}
      </div>
    </Activity>
  );
}
